import React from 'react';
import PropTypes from 'prop-types';
import { Globe, Users, Lock } from 'lucide-react';
import styles from './MeetSignupStatusBadge.module.css';

// Compact signup-status pill shown at the top of the Basic Information panel (§6.8). Reflects the meet's signup
// CONFIG (admin-only / self-service / public) and links to the public page when published. The live window
// state (open/closed/upcoming) arrives with the server-side gate (item 5).
const MeetSignupStatusBadge = ({ selfServiceEnabled = false, publicEnabled = false, signupCode = null }) => {
  const publicUrl = signupCode ? `${window.location.origin}/m/${signupCode}` : null;

  if (publicEnabled) {
    return (
      <span className={`${styles.badge} ${styles.public}`}>
        <Globe size={15} />
        <span>Public registration on</span>
        {publicUrl && (
          <a
            className={styles.link}
            href={publicUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            Open page ↗
          </a>
        )}
      </span>
    );
  }

  if (selfServiceEnabled) {
    return (
      <span className={`${styles.badge} ${styles.selfService}`}>
        <Users size={15} />
        <span>Self-service registration on</span>
      </span>
    );
  }

  return (
    <span className={`${styles.badge} ${styles.off}`}>
      <Lock size={14} />
      <span>Registration: admin only</span>
    </span>
  );
};

MeetSignupStatusBadge.propTypes = {
  selfServiceEnabled: PropTypes.bool,
  publicEnabled: PropTypes.bool,
  signupCode: PropTypes.string,
};

export default MeetSignupStatusBadge;
